import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { PostType, posts } from "./postsList";
// import { Helmet } from "react-helmet";
//import * as document from "../../assets/documents";

interface IProps {
  match: {
    params: any;
    isExact: boolean;
    path: string;
    url: string;
  };
}

const Post: React.FC<IProps> = ({ match: { params } }) => {
  const currentPost: PostType | undefined = React.useMemo(
    () => posts.find((post) => post.id === params.id),
    [params.id]
  );

  return currentPost ? (
    <Fragment>
      <div className="blur-bg post-details">
        <Link to="/">Back</Link>
        <h1 className="mb-5">{currentPost.title}</h1>
        <div className="post-details-text">
          {currentPost.body.map((textBlock) => (
            <div>
              <h2>{textBlock.h}</h2>
              {textBlock.p.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </div>
          ))}
        </div>
        {currentPost.attachements && (
          <div className="post-details-attachements">
            {currentPost.attachements
              .filter((attachement) => attachement.type === "document")
              .map((attachement) => (
                <a
                  href={`/documents${attachement.link}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Download Document
                </a>
              ))}
          </div>
        )}
      </div>

      <h4 className="other-posts-title">Other readings</h4>
      <div className="other-posts">
        {posts
          .filter((post) => post.id !== params.id)
          .slice(0, 4)
          .map((post) => (
            <div className="blur-bg" key={post.id}>
              <Link to={`/post/${post.id}`} className="post-link">
                <h3>{post.title}</h3>
              </Link>
            </div>
          ))}
      </div>
    </Fragment>
  ) : (
    <p>Post is not found</p>
  );
};

export default Post;
